const breakpoints = {
  xx: 0,
  xs: 425,
  sm: 768,
  md: 1024,
  lg: 1310,
  xl: 1600,
  none: null,
}

export const windowWidth = window?.innerWidth

export const currentBP =
  windowWidth >= breakpoints.xl
    ? 'xl'
    : windowWidth >= breakpoints.lg
    ? 'lg'
    : windowWidth >= breakpoints.md
    ? 'md'
    : windowWidth >= breakpoints.sm
    ? 'sm'
    : windowWidth >= breakpoints.xs
    ? 'xs'
    : 'xx'

export default breakpoints
